export default function isObject<T>(value: T) {
  return value instanceof Object
}
